import React, { useState, useRef } from "react";
import UserMultiSelect from "./UserMultiSelect";
import EmailEditor from "./EmailEditor";
import { sendEmail } from "./emailApi";

export default function EmailCampaignPage() {

 const [recipients, setRecipients] = useState([]);
 const [subject, setSubject] = useState("");
 const [body, setBody] = useState("");
 const [emailType, setEmailType] = useState("MARKETING");
 const [loading, setLoading] = useState(false);

 // ✅ NEW: store backend result
 const [result, setResult] = useState(null);

 // ✅ NEW: guard to prevent duplicate send
 const sendingRef = useRef(false);

 const handleSend = async () => {
 // 🚫 block duplicate calls (React StrictMode / double click)
 if (sendingRef.current) return;
 sendingRef.current = true;

 if (recipients.length === 0) {
 alert("Please select at least one recipient");
 sendingRef.current = false;
 return;
 }

 if (!subject.trim()) {
 alert("Subject cannot be empty");
 sendingRef.current = false;
 return;
 }

 setLoading(true);
 setResult(null);

 try {
 const response = await sendEmail({
 userIds: recipients.map(r => r.userId),
 emails: recipients.map(r => r.email),
 subject,
 body,
 emailType,
 html: true
 });

 const data = response.data;
 setResult(data);

 // ✅ reset form only if something was actually sent
 if (data.sent > 0) {
 setRecipients([]);
 setSubject("");
 setBody("");
 }

 } catch (e) {
 alert("Failed to send email");
 } finally {
 setLoading(false);
 sendingRef.current = false; // ✅ release lock
 }
 };

 return (
 <div style={{ maxWidth: 800, margin: "auto" }}>
 <h2 style={{ marginBottom: 20 }}>Email Campaign</h2>

 <div style={{ marginBottom: 16 }}>
 <label>Recipients</label>
 <UserMultiSelect onChange={setRecipients} />
 </div>

 <div style={{ marginBottom: 16 }}>
 <label>Subject</label>
 <input
 value={subject}
 onChange={e => setSubject(e.target.value)}
 style={{ width: "100%" }}
 />
 </div>

 <div style={{ marginBottom: 16 }}>
 <label>Email Type</label>
 <select
 value={emailType}
 onChange={e => setEmailType(e.target.value)}
 >
 <option value="MARKETING">Marketing</option>
 <option value="ANNOUNCEMENT">Announcement</option>
 <option value="TRANSACTIONAL">Transactional</option>
 </select>
 </div>

 <div style={{ marginBottom: 20 }}>
 <label>Body</label>
 <EmailEditor value={body} onChange={setBody} />
 </div>

 <button onClick={handleSend} disabled={loading}>
 {loading ? "Sending..." : "Send Email"}
 </button>

 {/* ✅ Result summary */}
 {result && (
 <div
 style={{
 marginTop: 24,
 padding: 16,
 border: "1px solid #ddd",
 borderRadius: 6
 }}
 >
 <h3>Campaign Result</h3>

 <p>
 Total: {result.total} <br />
 ✅ Sent: {result.sent} <br />
 ❌ Failed: {result.failed} <br />
 ⏭ Skipped: {result.skipped}
 </p>

 <hr />

 <ul>
 {result.results.map((r, idx) => (
 <li key={idx}>
 {r.email} —{" "}
 <strong
 style={{
 color:
 r.status === "SENT"
 ? "green"
 : r.status === "FAILED"
 ? "red"
 : "orange"
 }}
 >
 {r.status}
 </strong>
 {r.reason && ` (${r.reason})`}
 </li>
 ))}
 </ul>
 </div>
 )}
 </div>
 );
}
